const rippleShader = {
  uniforms: {
    uTexture: { value: null },
    uDisplacement: { value: null },
    opacity: { value: 1.0 },
    time: { value: 0.0 },
  },
  vertexShader: `
      varying vec2 vUv;
  
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
      }
    `,
  fragmentShader: `
      uniform float opacity;
  	  uniform sampler2D uDisplacement;
      uniform sampler2D uTexture;
      uniform float time;
  
      varying vec2 vUv;
  
      float PI = 3.141592653589793238;
  
        void main() {
       	vec4 displacement = texture2D(uDisplacement, vUv);
        float theta = displacement.r * 2.0 * PI;
        vec2 dir = vec2(sin(theta), cos(theta));
        vec2 uv = vUv + dir * displacement.r*0.1;
        vec4 color = texture2D(uTexture, uv);
        
        gl_FragColor = color;
        }
    `,
};

export { rippleShader };
